import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { Button } from "@jugl-web/ui-kit";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

type SaveUpToCardProps = {
  onGoYearly: () => void;
  isLoading?: boolean;
};

export const SaveUpToCard: React.FC<SaveUpToCardProps> = ({
  onGoYearly,
  isLoading,
}) => {
  const { t } = useTranslations();
  return (
    <div className="bg-dark relative h-[234px] overflow-hidden rounded-3xl bg-gradient-to-b from-[#FBF6FF] to-[#F1F8FF] p-8">
      <div className="relative flex h-full flex-col justify-between">
        <div>
          <h3 className="font-secondary text-dark my-0 text-3xl font-semibold">
            {t({
              id: "cx-plans-page.save-up-to-card-title",
              defaultMessage: "Save up to 18%",
            })}
          </h3>
          <p className="font-secondary text-dark-700 my-1 text-sm">
            {t({
              id: "cx-plans-page.save-up-to-card-description",
              defaultMessage:
                "Switch to annual billing to save up to 18% on a plan",
            })}
          </p>
        </div>
        <div>
          <Button
            variant="secondary"
            iconEnd={<ArrowRightIcon />}
            onClick={onGoYearly}
            isDisabled={isLoading}
          >
            {t({
              id: "cx-plans-page.save-up-to-card-button",
              defaultMessage: "Go Yearly",
            })}
          </Button>
        </div>
      </div>
    </div>
  );
};
